import 'zone.js';
import '@angular/localize/init';

// Fix needed for SockJS, see https://github.com/sockjs/sockjs-client/issues/439
//(window as any).global = window;

(window as any).process = {
  env: { DEBUG: undefined },
};

//Or npm i -S process, then add this to polyfill.ts:

//import * as process from 'process';
//window['process'] = process;
